import { render, staticRenderFns } from "./Form1CaseInformation.vue?vue&type=template&id=bbe8a766&scoped=true"
import script from "./Form1CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form1CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe8a766",
  null
  
)

export default component.exports